import { render, staticRenderFns } from "./StoreData.vue?vue&type=template&id=5dc70e27"
import script from "./StoreData.vue?vue&type=script&lang=js"
export * from "./StoreData.vue?vue&type=script&lang=js"
import style0 from "./StoreData.vue?vue&type=style&index=0&id=5dc70e27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports